import { render, staticRenderFns } from "./props.vue?vue&type=template&id=61cff42b&scoped=true&"
import script from "./props.vue?vue&type=script&lang=js&"
export * from "./props.vue?vue&type=script&lang=js&"
import style0 from "./props.vue?vue&type=style&index=0&id=61cff42b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cff42b",
  null
  
)

export default component.exports